import type { SxProps, Theme } from '@mui/material';

export const linkTargetChooserSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  px: 2,
  py: 1,
};

export const versionSelectSx: SxProps<Theme> = {
  ml: 4,
  maxWidth: 360,
};
